module.exports = __webpack_public_path__ + "static/instagram-5ba58b00f2fd9f9d4b2afff2092fd776.svg";